// extracted by mini-css-extract-plugin
export default {"productGallery":"NJ-z","inQuickShop":"OJ-z"};